<template>
    <Dialog v-model:visible="showDialog" :modal="true" header="Call Recording"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '40vw' }" @after-hide="IsClear">
        <b-container>
            <!-- {{ model }} -->
            <b-row>
                <b-col sm="12">
                    <Audioplayer :audios="model" />

                </b-col>
            </b-row>
            <!-- <b-form @submit.prevent="IsSubmit">
                <b-row>
                    <b-col sm="12">
                        <div class="field">
                            <TextFields id="code" name="code" :label="$t('crm.templatesetup.leadstatusmaster.code')"
                                :rules="{ required: false }" v-model="isForm.Code" placeholder=" " :disabled="true" />
                        </div>
                    </b-col>
                    <b-col sm="12">
                        <div class="field">
                            <TextFields id="name" name="name" :label="$t('crm.templatesetup.leadstatusmaster.name')"
                                :required-icon="true" :rules="{ required: true, alphanumeric: true }" v-model="isForm.Name"
                                type="text" placeholder=" " />
                        </div>
                    </b-col>
                    <b-col sm="12">
                        <div class="field">
                            <Textarea id="Remark" name="Remark" :label="$t('crm.templatesetup.leadstatusmaster.desc')"
                                :rules="{ required: false }" v-model="isForm.Description" placeholder=" " />
                        </div>
                    </b-col>
                    <b-col sm="12">
                        <div class="field">
                            <CustomDropdown v-model="isForm.Type" name="Type" :items="leadDropdownlist.TypeOption"
                                @update:modelValue="" id="Type" label="Type" :rules="{ required: true }"
                                :required-icon="true" />
                        </div>
                    </b-col>
                </b-row>
                <Footer @cancel="(showDialog = false), IsClear()" :cancelhide="false" :label="label" />
            </b-form> -->
            <Footer @cancel="(showDialog = false), IsClear()" :cancelhide="false" label="Audio Download"
                @save="downloadSong()" />

        </b-container>
    </Dialog>
    <CreateSuccessully :visible="successPop" @ok="closetrigger()" />
    <EditConfirmation :editModel="editModel" @yes="IsEdit()" @no="editModel = false"
        :content="$t('confirmation.editcontent')" />
    <UpdatedSuccessfully :visible="updatePop" @ok="closetrigger()" />
    <AlreadyExist :visible="alreadyExistPop" @ok="alreadyclosetrigger()" />
    <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import Footer from "../../../../components/FormComponents/Footer.vue";
import TextFields from "../../../../components/FormComponents/TextInput.vue";
import NumberField from "../../../../components/FormComponents/InputNumber.vue";
import Textarea from "../../../../components/FormComponents/TextArea.vue";
import { useForm } from "vee-validate";
import { useI18n } from 'vue-i18n';
import CreateSuccessully from "../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../components/FormComponents/EditConfirmation.vue";
import LeadStatusService from "../../service/leadStatus";
import AlreadyExist from "../../../../components/FormComponents/AlreadyExist.vue";
import commonService from "../../service/commonService";
// import CallRecordservice from "../../service/callRecordingService";

import CustomDropdown from "../../../../components/FormComponents/Dropdown.vue";
import Audioplayer from "../../components/Calls/CallRecordingPlayer.vue";
import axios from 'axios'
import { useToast } from "primevue/usetoast";

import { useHotkey } from 'v-hotkey3';
import moment from "moment";

export default defineComponent({
    props: {
        showDialog: {
            type: Boolean,
            default: ref(false),
        },
        selectedItem: {
            type: Object,
            Default: () => { },
        },
        showButton: {
            type: Boolean,
            required: false,
        },
    },
    components: {
        Audioplayer,
        CustomDropdown,
        CreateSuccessully,
        UpdatedSuccessfully,
        EditConfirmation,
        Footer,
        TextFields,
        Textarea,
        NumberField,
        AlreadyExist,
    },
    setup(props, { emit }) {
        debugger;
        const successPop = ref(false);
        const updatePop = ref(false);
        const alreadyExistPop = ref(false);
        const editModel = ref(false);
        const { t } = useI18n();
        const loading = ref(false);
        const { handleSubmit, errors } = useForm();
        const toast = useToast();

        const showDialog = ref();
        const model: any = ref(props.selectedItem);
        const label = ref(t('btn.save'));
        let localstoragedata = ref();
        localstoragedata.value = localStorage.getItem('UsersData')
        localstoragedata.value = JSON.parse(localstoragedata.value)
        onMounted(() => {
            IsEdit();
            debugger;
        });

        const leadDropdownlist = ref({
            TypeOption: [{
                name: 'Contact',
                value: 0
            },
            {
                name: 'Leads',
                value: 1
            },
            ],



        });
        // function handleFileChange(event) {
        //     const selectedFile = event.target.files[0];
        //     if (selectedFile) {
        //         playingAudio.value.url = URL.createObjectURL(selectedFile);
        //     }
        // }
        const isForm = ref({
            CreatedAt: "",
            ModifiedAt: "",
            CreatedBy: 0,
            ModifiedBy: 0,
            CreatedByName: "",
            Id: 0,
            Code: "",
            Name: "",
            Description: "",
            ClientId: 0,
            CreatedDate: "2023-07-14T07:10:35.851Z",
            UpdatedBy: 0,
            UpdatedDate: "2023-07-14T07:10:35.851Z",
            BranchId: ref(0),
            Type: ref()
        });
        const IsSubmit = handleSubmit(async (values) => {
            emit("loadershow");
            try {
                let result: any;
                let msg = "";
                isForm.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
                isForm.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
                isForm.value.ClientId = localstoragedata.value.OrganizationId
                isForm.value.BranchId = localstoragedata.value.BranchId
                if (isForm.value.Id != 0) {
                    isForm.value.CreatedDate = "2023-02-10T05:35:01.084Z";
                    isForm.value.UpdatedDate = "2023-02-10T05:35:01.084Z";
                    let result = await LeadStatusService.update(isForm.value);
                    let msg = result["ErrorInfo"].ErrorCode;
                    if (result["result"] == "Already" && msg == null) {
                        loading.value = false;
                        alreadyExistPop.value = true;
                    } else if (msg == null) {
                        emit("loaderhide");
                        updatePop.value = true;
                    }
                } else {
                    let result = await LeadStatusService.create(isForm.value);
                    let msg = result["ErrorInfo"].ErrorCode;
                    if (result["result"] == "Already" && msg == null) {
                        emit("loaderhide");
                        alreadyExistPop.value = true;
                    } else if (msg == null) {
                        emit("loaderhide");
                        successPop.value = true;
                    }
                }
            } catch (error) {
                emit("loaderhide");
                console.log(error);
            }
        });
        //findone function
        const IsEdit = async () => {
            debugger;
            // alert('s')
            loading.value = true;
            showDialog.value = true;
            // alert(JSON.stringify(model.value))
            try {
                label.value = "Update";
                debugger;
                // const response = await CallRecordservice.getById(model.value.Id);
                // let data = response["result"];
                // alert(JSON.stringify(data))
                // Object.keys(isForm.value).forEach((key) => {
                //     if (data[key]) isForm.value[key] = data[key];
                // });
                loading.value = false;
            } catch (error) {
                loading.value = false;
                alert(error);
            }
        };
        if (model.value != null) {
            IsEdit();
        } else {
            IsCreate();

        }

        async function GetCode() {
            debugger;
            let data = {
                FormId: 1,
                HospitalId: localstoragedata.value.OrganizationId,
                BranchId: localstoragedata.value.BranchId,
            };
            let result: any = await commonService.getCodeTemplate(data);
            debugger;
            console.log(result);
            isForm.value.Code = result;
        }


        function IsCreate() {
            showDialog.value = true;
            GetCode()
        }
        const IsClear = () => {
            isForm.value.Id = 0;
            isForm.value.Name = "";
            isForm.value.Description = "";
            emit("update:selectedItem", undefined);
            emit("close");
            emit("load");
        };
        //popup create
        async function IsEditpop() {
            editModel.value = true;
        }
        //Created Sucessfully Popup-Close
        function closetrigger() {
            IsClear();
            emit("load");
            successPop.value = false;
            updatePop.value = false;
            showDialog.value = false;
        }
        useHotkey({
            'ctrl+s': () => {
                IsSubmit()
            },
            'esc': () => {
                closetrigger()
            },
            'enter': {
                keydown() {
                    alert('test')
                },
            }
        })
        function alreadyclosetrigger() {
            debugger;
            alreadyExistPop.value = false;
        }
        const downloadSong = async () => {
            try {
                // if (!model.recordingUrl) {
                //     console.error('Recording URL is not defined.');
                //     return;
                // }

                const token = 'd7a599973e6b023319d1bf7b77d8ad1b'; // Replace with your actual token

                // Append the token as a query parameter to the URL
                const urlWithToken = 'https://cloudphone.tatateleservices.com/file/recording?callId=1691663994.920461&type=rec&token=d7a599973e6b023319d1bf7b77d8ad1b';

                const response = await axios({
                    url: urlWithToken,
                    method: 'GET',
                    responseType: 'blob',
                });

                // Create a blob from the response data
                const blob = new Blob([response.data], { type: 'audio/mpeg' });

                // Create a URL for the blob
                const blobURL = window.URL.createObjectURL(blob);

                // Create a link element
                const fileLink = document.createElement('a');
                fileLink.href = blobURL;
                fileLink.download = 'CallRecording.mp3'; // Set the desired file name

                // Trigger a click event on the link to initiate the download
                fileLink.dispatchEvent(new MouseEvent('click'));

                // Clean up by revoking the blob URL
                window.URL.revokeObjectURL(blobURL);
                // toast.add({
                //     severity: "success",
                //     summary: "Downloaded Successfully",
                //     detail: "",
                //     life: 3000,
                // });
                // showDialog.value = false
            } catch (error) {
                console.error('Error downloading the song:', error);

            }
        }

        // if (model.value != null) {
        //     IsEdit();
        // } else {
        //     IsCreate();
        // }
        return {
            model,
            downloadSong,
            // downloadAudio,
            leadDropdownlist,
            IsEditpop,
            closetrigger,
            editModel,
            updatePop,
            successPop,
            showDialog,
            IsCreate,
            IsClear,
            IsEdit,
            isForm,
            IsSubmit,
            label,
            loading,
            alreadyExistPop,
            alreadyclosetrigger,
            localstoragedata
        };
    },
});
</script>
